import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MapService } from '../../services/map.service';

@Component({
    selector: 'app-sequential-search',
    templateUrl: './sequential-search.component.html',
    styleUrls: ['./sequential-search.component.scss']
})
export class SequentialSearchComponent implements OnInit {
    baladeyaNameOptions: string[] = [];
    planNameOptions: string[] = [];
    parcelNoOptions: string[] = [];
    baladeyaName: string;
    planName: string;
    parcelNo: string;
    constructor(
        private http: HttpClient,
        private mapService: MapService
    ) { }

    ngOnInit(): void {
        this.fetchOptions();
    }

    // private fetchOptions(): void {
    //   const layerUrl = 'http://192.168.1.106:6080/arcgis/rest/services/Amana/Amana/FeatureServer/1/query?f=json&where=1%3D1&returnGeometry=false&outFields=PLAN_NAME,PARCELNO';

    //   this.http.get(layerUrl).subscribe(
    //     (response: any) => {
    //       const features = response?.features;

    //       if (features) {
    //         features.forEach((feature: any) => {
    //           const baladeyaName = feature?.attributes?.BELEDIYE;
    //           const planName = feature?.attributes?.PLAN_NAME;
    //           const parcelNo = feature?.attributes?.PARCELNO;

    //           if (baladeyaName && !this.baladeyaNameOptions.includes(baladeyaName)) {
    //             this.baladeyaNameOptions.push(baladeyaName);
    //           }
    //           if (planName && !this.planNameOptions.includes(planName)) {
    //             this.planNameOptions.push(planName);
    //           }

    //           if (parcelNo && !this.parcelNoOptions.includes(parcelNo)) {
    //             this.parcelNoOptions.push(parcelNo);
    //           }

    //         });
    //       }
    //     },
    //     (error: any) => {
    //       console.error('Error fetching options:', error);
    //     }
    //   );
    // }

    public fetchOptions() {
        // Fetch data from the first layer (FeatureServer/1)
        const layerUrl1 =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=SUBDIVISIONPLANNAME_AR,PARCEL_ID';

        this.http.get<any>(layerUrl1).subscribe(
            (response1) => {
                this.processLayerData(response1);

                // Fetch data from the second layer (FeatureServer/5)
                const layerUrl2 =
                    'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/8/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=BELEDIYE';

                this.http.get(layerUrl2).subscribe(
                    (response2) => {
                        this.processLayerData(response2);
                    }
                    // ,
                    // (error: any) => {
                    //   console.error('Error fetching options from the second layer:', error);
                    // }
                );
            }
            // (error: any) => {
            //   console.error('Error fetching options from the first layer:', error);
            // }
        );
    }

    private processLayerData(response: any): void {
        const features = response?.features;
        // debugger;
        if (features) {
            features.forEach((feature: any) => {
                const baladeyaName = feature?.attributes?.BELEDIYE;
                const planName = feature?.attributes?.SUBDIVISIONPLANNAME_AR;
                const parcelNo = feature?.attributes?.PARCEL_ID;

                if (
                    baladeyaName &&
                    !this.baladeyaNameOptions.includes(baladeyaName)
                ) {
                    this.baladeyaNameOptions.push(baladeyaName);
                }
                if (planName && !this.planNameOptions.includes(planName)) {
                    this.planNameOptions.push(planName);
                }

                if (parcelNo && !this.parcelNoOptions.includes(parcelNo)) {
                    this.parcelNoOptions.push(parcelNo);
                }
            });
        }
    }

    onBaladeyaNameChange(event: any): void {
        // const selectedValue = event.target.value;
        this.setFilter();
    }

    onPlanNameChange(event: any): void {
        this.setFilter();
    }

    onParcelNoChange(event: any): void {
        this.setFilter();
    }
    private setBaladeyaFilter(): string {
        const baladeya = this.mapService.mapImgLayer.findSublayerById(8);
        let output = '';
        if (this.baladeyaName !== '') {
            output = `BELEDIYE= N'${this.baladeyaName}'`;
            baladeya.definitionExpression = output;
        }

        return output;
    }

    private setFilter(): string {
        let output: any;
        let bname: any = document.getElementById('baladeya');
        this.baladeyaName = bname.value;
        let pname: any = document.getElementById('planName');
        this.planName = pname.value;
        let parNo: any = document.getElementById('parcelno');
        this.parcelNo = parNo.value;

        const parcel = this.mapService.mapImgLayer.findSublayerById(2);
        const baladeya = this.mapService.mapImgLayer.findSublayerById(8);

        if (
            this.baladeyaName != '' &&
            this.planName == '' &&
            this.parcelNo == ''
        ) {
            //
            parcel.definitionExpression = '';
            output = this.setBaladeyaFilter();
            baladeya.definitionExpression = `BELEDIYE= N'${this.baladeyaName}'`;
        } else if (
            this.baladeyaName == '' &&
            this.planName != '' &&
            this.parcelNo == ''
        ) {
            // //
            output = "SUBDIVISIONPLANNAME_AR= N'" + this.planName + "'";
            parcel.definitionExpression = output;
            baladeya.definitionExpression = '';
        } else if (
            this.baladeyaName == '' &&
            this.planName == '' &&
            this.parcelNo != ''
        ) {
            //
            output = "PARCEL_ID= N'" + this.parcelNo + "'";
            parcel.definitionExpression = output;
            baladeya.definitionExpression = '';
        } else if (
            this.baladeyaName != '' &&
            this.planName != '' &&
            this.parcelNo == ''
        ) {
            output = this.setBaladeyaFilter(); // + "' And PLAN_NAME= N'"+ this.planName + "'"
            parcel.definitionExpression =
                "SUBDIVISIONPLANNAME_AR= N'" + this.planName + "'";
            baladeya.definitionExpression = `BELEDIYE= N'${this.baladeyaName}'`;
        } else if (
            this.baladeyaName != '' &&
            this.planName == '' &&
            this.parcelNo != ''
        ) {
            output = this.setBaladeyaFilter(); //+ "' And PARCELNO= N'"+ this.parcelNo+ "'"
            parcel.definitionExpression = "PARCEL_ID= N'" + this.parcelNo + "'";
            baladeya.definitionExpression = `BELEDIYE= N'${this.baladeyaName}'`;
        } else if (
            this.baladeyaName == '' &&
            this.planName != '' &&
            this.parcelNo != ''
        ) {
            output =
                "SUBDIVISIONPLANNAME_AR= N'" +
                this.planName +
                "' AND PARCEL_ID= N'" +
                this.parcelNo +
                "'";
            parcel.definitionExpression = output;
            baladeya.definitionExpression = '';
        } else if (
            this.baladeyaName != '' &&
            this.planName != '' &&
            this.parcelNo != ''
        ) {
            output = this.setBaladeyaFilter(); //+ "' And PLAN_NAME= N'"+ this.planName + "' AND PARCELNO= N'"+ this.parcelNo+ "'"
            parcel.definitionExpression =
                "SUBDIVISIONPLANNAME_AR= N'" +
                this.planName +
                "' AND PARCEL_ID= N'" +
                this.parcelNo +
                "'";
            baladeya.definitionExpression = `BELEDIYE= N'${this.baladeyaName}'`;
        } else {
            output = '';
            parcel.definitionExpression = '';
            baladeya.definitionExpression = '';
        }
        return output;
    }
}
